(function () {
  'use strict';

  window.eventBus = {
    pub: function (event, data) {
      const ev = new CustomEvent(event, {detail: data});
      this._target.dispatchEvent(ev);
    },
    sub: function (event, callback) {
      this._target.addEventListener(event, callback);
    },
    _target: new EventTarget()
  };

})();
